export default {"src":"/_next/static/media/eye-icon.e35fac56.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};